
import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

// Use environment variables - no hardcoded fallbacks for security
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing required Supabase environment variables. Please check your .env file.')
}

// Production can opt into the Vercel proxy for networks that block supabase.co.
// Preview/staging must use its configured Supabase URL directly so it cannot
// authenticate against or write to the production project by accident.
const useSupabaseProxy = import.meta.env.VITE_USE_SUPABASE_PROXY === 'true'
const effectiveUrl = useSupabaseProxy && typeof window !== 'undefined'
  ? `${window.location.origin}/supabase`
  : supabaseUrl

export const supabase = createClient<Database>(
  effectiveUrl,
  supabaseAnonKey,
  {
    auth: {
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
    }
  }
)
